"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TransformYourHomesKerbAppeal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222735" id="the-peace-river-standard" className="bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden light">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/punta_gorda_residential_landscape.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-background/10 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_var(--color-background)_100%)] opacity-100" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 text-center px-4 max-w-5xl mx-auto flex flex-col items-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <p className="text-2xl md:text-2xl text-primary mb-4 font-default tracking-wider drop-shadow-none font-semibold">941-888-0485</p>

        <h1 className="font-default font-bold text-primary mb-6 drop-shadow-none tracking-tighter leading-none uppercase !text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Pest Control IN Punta Gorda | Professional and Local Pest Protection for Your HOME and business</h1>
        
        <p className="text-base md:text-lg lg:text-2xl text-primary mb-12 font-serif max-w-3xl drop-shadow-none font-normal leading-relaxed">Looking for reliable <Link to="/PestControlPage" className="underline decoration-primary/30 hover:decoration-primary transition-colors">pest control services</Link> in Punta Gorda, FL? Peace River Pest Control provides effective, affordable pest protection for ants, <Link to="/TermiteTreatmentPage" className="underline decoration-primary/30 hover:decoration-primary transition-colors">termite treatment</Link>, roaches, spiders, <Link to="/MosquitoControlPage" className="underline decoration-primary/30 hover:decoration-primary transition-colors">mosquito control solutions</Link>, and more. Our protection plans, whether performed quarterly, bi-monthly, or monthly, are designed to keep your home or business pest-free year-round, and are backed by local expertise and dependable service.</p>

        <Button asChild size="lg" className="px-10 py-7 text-lg md:text-xl rounded-lg font-bold transition-all hover:scale-110 bg-primary text-primary-foreground border-none uppercase tracking-widest">
          <Link to="/ContactPage">Schedule Free Inspection</Link>
        </Button>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <ChevronDown className="w-10 h-10 text-primary animate-bounce drop-shadow-none" />
      </div>
    </section>;
}